import {Text, View, Image} from '@react-pdf/renderer';
import styles from '../styles';
import topLogo from '../../../assets/image/pdf/mazraE_top_logo.png';
import clockIcon from '../../../assets/image/pdf/clock_icon.svg';
import calendarIcon from '../../../assets/image/pdf/calendar_icon.svg';
import {getShamsiDate, getTimeString} from '../utils/formatData';

const Header: React.FC<{
  serialNumber: string;
}> = ({serialNumber: fileNumber}) => (
  <View style={styles.header} fixed>
    <View style={styles.headerRight}>
      <Image source={topLogo} style={{height: 30}} />
    </View>
    <View style={styles.headerLeft}>
      <View style={styles.headerInfoBlock}>
        <Text
          style={styles.headerInfoText}
        >{`شماره پرونده: ${fileNumber}`}</Text>
      </View>
      <View style={styles.headerInfoBlock}>
        <Image style={styles.icon} source={calendarIcon} />
        <Text style={styles.headerInfoText}>{getShamsiDate()}</Text>
      </View>
      <View style={styles.headerInfoBlock}>
        <Image style={styles.icon} source={clockIcon} />
        <Text style={styles.headerInfoText}>{getTimeString()}</Text>
      </View>
    </View>
  </View>
);

export default Header;
